import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { IdentityProvisioningService } from "../../identity-provisioning/identity-provisioning.service";

@Component({
  selector: "app-delete-dialog",
  template: `

     <div class="text-center pt-4">
  <i class="bi bi-exclamation-triangle text-warning fs-1"></i>
</div>

<div class="mx-5 pt-2">
  <h1 class="text-center">{{ data.title }}</h1>
</div>

<div class="mx-5 text-center">
  <p>{{ data.message }}</p>
</div>

<div class="pt-2 pb-4 d-flex justify-content-center gap-2 flex-wrap">
  <button type="button" class="btn btn-submit" (click)="redirectTo()">OK</button>
  
  <button type="button" class="btn btn-outline-submit" (click)="redirectToDeltaChange()">
    Delta Change
  </button>
  
  <button type="button" class="btn btn-outline-submit" (click)="redirectToOverride()">
    Override
  </button>
</div>




  `,
  styles:[
    `  .btn-submit {
  background-color: #0060d6;
  color: #ffff;
  transition: background 0.3s ease-in-out;

  &:hover{
     background-color: #1a1a86;
  }
}
  .btn-outline-submit{
  color: #1a1a86;
  background: transparent;
  border-color: #1a1a86;

  &:hover{
    color: white;
    background: #1a1a86;

  }
  }`
  ]
})
export class ImportFailDialogComponent {
  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      path: string;
      orgnization: string;
      pathoverride: string;
    },
    private dialog: MatDialog,
    private identityProvisioningService: IdentityProvisioningService
  ) {}

  redirectTo() {
    this.dialog.closeAll();
    this.router.navigate([this.data.path]);
  }

  async redirectToDeltaChange() {
    this.dialog.closeAll();
    const response = await this.identityProvisioningService
      .deltaChangeEmpDetails(this.data.orgnization)
      .toPromise();
    this.router.navigate([this.data.pathoverride]);
  }

  async redirectToOverride() {
    this.dialog.closeAll();
    const response = await this.identityProvisioningService
      .overrideEmpDetails(this.data.orgnization)
      .toPromise();
    this.router.navigate([this.data.pathoverride]);
  }
}
